import { Link } from 'react-router-dom';
import { animeList, latestAnimeIds } from '@/mocks/anime';

export default function LatestUpdates() {
  const latest = animeList.filter((a) => latestAnimeIds.includes(a.id));

  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14 bg-background-100/50">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
          <i className="ri-timer-flash-line text-primary-400 mr-2"></i>最新更新
        </h2>
        <Link
          to="/category/japanese"
          className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
        >
          更多更新 <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {latest.map((anime) => (
          <Link
            key={anime.id}
            to={`/article/${anime.id}`}
            className="flex gap-3 p-3 rounded-lg bg-background-50 hover:bg-background-200/70 transition-all cursor-pointer group"
          >
            <div className="w-16 h-20 md:w-20 md:h-[108px] flex-shrink-0 rounded-md overflow-hidden">
              <img
                src={anime.coverImage}
                alt={anime.title}
                title={`${anime.title} - 樱花动漫网在线观看`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-1 min-w-0 flex flex-col justify-between py-1">
              <div>
                <h3 className="text-sm font-medium text-foreground-100 group-hover:text-accent-400 transition-colors line-clamp-2 leading-snug">
                  {anime.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{anime.updateInfo}</p>
              </div>
              <div className="flex items-center gap-1">
                <i className="ri-star-fill text-xs text-secondary-400"></i>
                <span className="text-xs text-secondary-400 font-medium">{anime.rating}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}